import { useTranslation } from 'react-i18next';

import { AutoSave } from './AutoSave.jsx';
import { TileActionText } from './TileActionText.jsx';
import { SaveAndCloseButton } from './TileActionButtons.jsx';

import { LeftButton, RightButton } from './StyledComponents';

export const EditFormMenu = ({
  goToPreview,
  campaignContainer,
  postId,
  tileStatus,
  publishDate,
  onClose,
  uuid,
  autoSaved,
}) => {
  const { t } = useTranslation('tileForm');

  return (
    <>
      <LeftButton mode="outline" variant="black" onClick={onClose}>
        <SaveAndCloseButton />
      </LeftButton>
      <AutoSave autoSaved={autoSaved} />
      <TileActionText
        publishDate={publishDate}
        tileStatus={tileStatus}
        postId={postId}
        campaignContainer={campaignContainer}
        uuid={uuid}
      />
      <RightButton
        uuid={uuid}
        mode="outline"
        onClick={goToPreview}
        variant="black"
      >
        <i className="fa-light fa-eye fa-lg"></i>
        {t('tileActionMenu.preview')}
      </RightButton>
    </>
  );
};
